import { useRef } from "react";
import Banner from "./Banner";
import JobInformation from "./JobInformation";
import FormSection from "./FormSection";


const jobContent = {
  title: "PHP Developer",

  summary:
    "We are on the lookout for a motivated and enthusiastic PHP Developer to join us as a fresher. The ideal candidate should have a strong foundation in PHP programming, a willingness to learn, and the drive to contribute meaningfully to development projects. This is a great opportunity to work with experienced developers and get hands-on experience in building scalable web applications.",

  sections: [
    {
      heading: "Key Responsibilities",
      points: [
        "Assist in the design, development, testing, and deployment of web applications using PHP.",
        "Work primarily on back-end components and integrate front-end elements.",
        "Collaborate with UI/UX teams, designers, and other developers to deliver efficient solutions.",
        "Write clean, maintainable, and well-documented code.",
        "Integrate third-party services and RESTful APIs.",
      ],
    },
    {
      heading: "Qualifications",
      points: [
        "Bachelor’s degree in Computer Science, IT, Engineering, or a related field.",
        "(Eligible: B.Sc (CS/IT), B.E/B.Tech, BCA, MCA)",
        "Basic understanding of web development concepts and PHP environment.",
        "Internship or academic project experience in PHP or web development is a plus.",
      ],
    },
    {
      heading: "Skills & Competencies",
      points: [
        "Proficiency in PHP programming language.",
        "Familiarity with PHP frameworks such as Lumen, Laravel, or CodeIgniter (preferred).",
        "Working knowledge of jQuery, AJAX, and React or any other frontend framework (preferred).",
        "Basic understanding of RESTful APIs and integration techniques.",
        "Strong analytical and problem-solving skills.",
        "Excellent communication and teamwork abilities.",
      ],
    },
    {
      heading: "Why Join Us?",
      points: [
        "Work on live projects and real-world applications.",
        "Learn and grow under the guidance of experienced professionals.",
        "Friendly and collaborative work culture.",
        "Opportunity to build a strong foundation for a successful career in web development.",
      ],
    },
  ],
};


const JobDetails = () => {
  const applyFormRef = useRef(null);

  return (
    <>
      <div className="bg-white text-gray-800">

        <Banner
          config={{
            applyFormRef,
            title: jobContent.title,
          }}
        />

        <div className="bg-white px-6 md:px-16 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-start">
            
            <div className="lg:col-span-2 space-y-12">
              <div>
                <h2 className="text-[32px] font-semibold text-[#212129] mb-6">
                  Job Summary
                </h2>

                <p className="text-[#212129] text-[18px] leading-8 mb-6">
                  {jobContent.summary}
                </p>
              </div>

              {jobContent.sections.map((section, index) => (
                <div key={index}>
                  <h3 className="text-[20px] font-semibold text-green-600 mb-1">
                    {section.heading}
                  </h3>

                  <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

                  <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
                    {section.points.map((point, i) => (
                      <li key={i}>{point}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            {/* RIGHT SIDE */}
            <JobInformation />
          </div>
        </div>
      </div>

      <FormSection applyFormRef={applyFormRef} />
    </>
  );
};

export default JobDetails;
